import serviceBase from '@/services/serviceBase'

class gradeService extends serviceBase {
    constructor() {
        super(process.env.VUE_APP_API_ENDPOINT)
    }

    getGrades(idProduto, tipoGrade) {
        return this.get(`${ this.getSubdominio() }/grade?id=${ idProduto }+&tipoGrade=${tipoGrade}`)
    }

}

export default new gradeService()


